module.exports = __webpack_public_path__ + "img/7bbf7a5.png";